import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caps'
})
export class CapsPipe implements PipeTransform {

  transform(value: string): string {
    // console.log(value)
    value = String(value).trim();
    if(value && value!=''){
      return String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase();
    }
    return value;
  }

}
